// src/components/ProtectedRoute.jsx
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';

const ProtectedRoute = ({
    isAuthenticated,
    currentUser,
    element: Component,
    requiredRole,
    requiredNavModule,
    requiredNavManage
}) => {
    const { loading } = useContext(UserContext);

    console.log('ProtectedRoute Debug:', {
        isAuthenticated,
        currentUserRole: currentUser?.role,
        requiredRole,
        loading
    });

    if (loading) {
        // Puedes personalizar este loader
        return <div className="flex items-center justify-center h-screen">Cargando...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (requiredRole) {
        const allowedRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
        if (!allowedRoles.includes(currentUser.role)) {
            return <Navigate to="/dashboard" replace />;
        }
    }

    if (requiredNavManage && !currentUser?.navAccess?.canManageNav) {
        return <Navigate to="/dashboard" replace />;
    }

    if (requiredNavModule) {
        const nav = currentUser.navAccess || {};
        if (!nav[requiredNavModule] && !nav.isSuperAdmin) {
            return <Navigate to="/dashboard" replace />;
        }
    }

    return <Component />;
};

export default ProtectedRoute;